import { Text, useInfoModal, useRouter } from '@capsicum/common-web';
import { useWCPledgeSuccessModalTexts } from '@capsicum/features/world-championship-pledge/shared';
import styled from 'styled-components';

export const useWCPledgeSuccessModal = () => {
	const { buttonText, content, subtitle, title } = useWCPledgeSuccessModalTexts();
	const { showInfoModal } = useInfoModal();
	const { push } = useRouter();

	const openWCPledgeSuccessModal = (amountStaked: number | string) => {
		showInfoModal({
			buttonOnHandlers: {
				onPrimaryButtonHandler: () => {
					push('/locker-room-internationals?empty_basket=true&tab=activity');
				}
			},
			buttonTexts: {
				primaryButtonText: buttonText
			},
			content: <S.ContentText variant="text3">{content}</S.ContentText>,
			image: 'chzAmount',
			isClosable: false,
			subtitle,
			testID: 'wcPledge-txSuccess-modal',
			title: title(amountStaked),
			variant: 'alert'
		});
	};

	return {
		openWCPledgeSuccessModal
	};
};

namespace S {
	export const ContentText = styled(Text)`
		text-align: center;
	`;
}
